import * as React from 'react';
import { InlineText2, InlineText3 } from '@cian/ui-kit';
import * as styles from './SubwayInfo.css';

interface ISubwayInfoProps {
  title: string;
  color: React.ReactElement | null;
  timeToSubway: string | null;
}

export function SubwayInfo({ title, color, timeToSubway }: ISubwayInfoProps) {
  return (
    <div className={styles['info']}>
      <span className={styles['info__subway']}>
        <span className={styles['info__subway-color']}>{color}</span>
        <InlineText2>{title}</InlineText2>
      </span>
      <mark className={styles['info__time']}>
        <InlineText3>{timeToSubway}</InlineText3>
      </mark>
    </div>
  );
}
